import React from 'react';
import classNames from 'classnames/bind';
import { useSwiperSlide } from 'swiper/react';
import { enhancedConnect } from "../../../utils";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _CarouselActiveLogic = function _CarouselActiveLogic(_ref) {
  var children = _ref.children;
  var _useSwiperSlide = useSwiperSlide(),
    isActive = _useSwiperSlide.isActive;
  if (React.Children.count(children) > 2) {
    console.error('CarouselActiveLogic принимает только 2 компонента');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('carousel-active-logic', isActive ? 'active' : 'inactive'),
    "data-t-id": "Carousel-CarouselActiveLogic"
  }, children);
};
export var CarouselActiveLogic = enhancedConnect()(_CarouselActiveLogic);